// extracted by mini-css-extract-plugin
export default {"main":"NewVisa_main__+4MvB","swiperCont":"NewVisa_swiperCont__Npwd4","box":"NewVisa_box__5aojj","contentCol":"NewVisa_contentCol__xk44+","swiperSlide":"NewVisa_swiperSlide__gfUZe"};